import type React from 'react';
import type { CartItem } from '../../Store/CartItem/state';
import ProductOverview from './ProductOverview';
import type { AvailableUpsellGroups } from '../../Store/Upsell/state';

interface ProductOverviewContainerProps {
    availableUpsellGroups: AvailableUpsellGroups;
    onCartItemAmountChange: (cartItemId: string, newAmount: string) => void;
    onCartItemDelete: (cartItemId: string) => void;
    onCartItemMessageDelete: (cartItemId: string) => void;
    products: Record<string, CartItem>;
}

const ProductOverviewContainer: React.FC<ProductOverviewContainerProps> = (
    {
        availableUpsellGroups,
        onCartItemAmountChange,
        onCartItemDelete,
        onCartItemMessageDelete,
        products,
    },
) => (
    <>
        {Object.entries(products).map(([key, product], index) => (
            <ProductOverview
                lazyLoadPreview={index > 0}
                key={key}
                product={product}
                onAmountChange={(newAmount: string) => onCartItemAmountChange(key, newAmount)}
                onProductDelete={() => onCartItemDelete(key)}
                onProductMessageDelete={() => onCartItemMessageDelete(key)}
                giftCard={product.giftCard}
                availableUpsellGroups={availableUpsellGroups[key] ?? []}
            />
        ))}
    </>
);
export default ProductOverviewContainer;
